<template lang="pug">
  .row.middle
    input.hide(type='checkbox' :id='`checkbox-${name}`' :name='name')
    label.checkbox.row.middle.space-between(
      :for='`checkbox-${name}`'
      :class='{ right: rightCheckbox, hover: hoverCheckbox, pointer: !disabled }'
      @click='updateStatus'
    )
      .row.middle
        simple-svg(
          width='18px'
          height='18px'
          v-show='checked'
          :filepath='activeCheckbox'
          :class='{noMargin: !label, circle, "blue-icon": !white, "white-icon": white}'
        )
        simple-svg(
          width='18px'
          height='18px'
          v-show='!checked'
          :filepath='inactiveCheckbox'
          :class='{noMargin: !label, circle, "blue-icon": !white, "white-icon": white}'
        )
        span.text-normal.m-left-1(v-if='label') {{ label }}
      span.text-xsmall.gray(v-if='disabled') {{ disabledText }}
</template>

<script>
import emptyCheckbox from '@/assets/ic_checkbox.svg'
import activeCheckbox from '@/assets/ic_checkbox-active.svg'
import activeFilledCheckbox from '@/assets/ic_checkbox-active2.svg'

import emptyCircleCheckbox from '@/assets/ic_circle_empty.svg'
import activeCircleCheckbox from '@/assets/ic_checkbox_rounded-active.svg'
import { checked, notChecked } from '../../utils/constants'

export default {
  props: {
    name: { type: [String, Number], required: false },
    label: { type: String, required: false },
    updateCheck: { type: Function, required: false },
    checked: { type: Boolean },
    disabled: { type: Boolean },
    disabledText: { type: String },
    rightCheckbox: { type: Boolean },
    hoverCheckbox: { type: Boolean },
    white: { type: Boolean },
    filled: { type: Boolean, default: true },
    circle: { type: Boolean }
  },
  computed: {
    setAlt() {
      return this.$t(`dashboard.${this.checked ? checked : notChecked}`)
    },
    activeCheckbox() {
      return this.circle
        ? activeCircleCheckbox
        : this.filled ? activeFilledCheckbox : activeCheckbox
    },
    inactiveCheckbox() {
      return this.circle
        ? emptyCircleCheckbox
        : emptyCheckbox
    }
  },
  methods: {
    updateStatus(evt) {
      if (!this.updateCheck) return evt.preventDefault()
      if (!this.disabled && this.updateCheck) this.updateCheck(this.name, !this.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
.checkbox {
  box-sizing: border-box;
  vertical-align: middle;
  width: 100%;
}

.pointer{
  cursor: pointer;
}

.checkbox-image {
  height: 22px;
  margin-right: 5px;
  width: 22px;
  &.noMargin{
    margin: 0;
  }
}

.hover {
  padding: 10px;

  &:hover {
    background-color: $light-gray;
  }
}

.right {
  margin: 0 0 0 8px;
  order: 1;
}
</style>
